export enum DocumentContentTypeEnum {
    Pdf = 'application/pdf',
    Html = 'text/html',
    Docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    Doc = 'application/msword',
    Png = 'image/png',
    Jpeg = 'image/jpeg',
}

export enum DossierTypeEnum {
    Client = 'client',
    Notary = 'notary',
    Provider = 'provider',
}
